import { createAction, props } from '@ngrx/store';
import { CollectionDocumentsRemoval, DocumentCollection, FavoriteCollection } from './collections.models';

export const loadCollections = createAction('[Collections] Load Collections');

export const loadCollectionsSuccess = createAction(
  '[Collections] Load Collections Success',
  props<{ collections: FavoriteCollection[]; bookmarkCount: number | null }>(),
);

export const loadCollectionsFailure = createAction(
  '[Collections] Load Collections Failure',
  props<{ error: unknown }>(),
);

export const createCollection = createAction('[Collections] Create Collection', props<{ name: string }>());

export const createCollectionSuccess = createAction(
  '[Collections] Create Collection Success',
  props<{ collection: DocumentCollection }>(),
);

export const createCollectionFailure = createAction(
  '[Collections] Create Collection Failure',
  props<{ error: unknown }>(),
);

// Optimistic: the new name is applied immediately, previousName is restored if the request fails
export const renameCollection = createAction(
  '[Collections] Rename Collection',
  props<{ id: number; name: string; previousName: string }>(),
);

export const renameCollectionSuccess = createAction(
  '[Collections] Rename Collection Success',
  props<{ id: number; name: string }>(),
);

export const renameCollectionFailure = createAction(
  '[Collections] Rename Collection Failure',
  props<{ id: number; name: string; previousName: string; error: unknown }>(),
);

export const deleteCollection = createAction('[Collections] Delete Collection', props<{ id: number }>());

export const deleteCollectionSuccess = createAction('[Collections] Delete Collection Success', props<{ id: number }>());

export const deleteCollectionFailure = createAction(
  '[Collections] Delete Collection Failure',
  props<{ id: number; error: unknown }>(),
);

export const addDocumentsToCollection = createAction(
  '[Collections] Add Documents To Collection',
  props<{ collectionId: number; documentIds: number[] }>(),
);

export const addDocumentsToCollectionSuccess = createAction(
  '[Collections] Add Documents To Collection Success',
  props<{ collectionId: number; documentIds: number[] }>(),
);

export const addDocumentsToCollectionFailure = createAction(
  '[Collections] Add Documents To Collection Failure',
  props<{ collectionId: number; documentIds: number[]; error: unknown }>(),
);

// Removes documents from one or more collections in parallel (one request per collection)
export const removeDocumentsFromCollections = createAction(
  '[Collections] Remove Documents From Collections',
  props<{ removals: CollectionDocumentsRemoval[] }>(),
);

export const removeDocumentsFromCollectionsSuccess = createAction(
  '[Collections] Remove Documents From Collections Success',
  props<{ removals: CollectionDocumentsRemoval[] }>(),
);

export const removeDocumentsFromCollectionsFailure = createAction(
  '[Collections] Remove Documents From Collections Failure',
  props<{ removals: CollectionDocumentsRemoval[]; error: unknown }>(),
);
